import { setVis } from "../../../helpers/setVis";

export const hideAndRemove = (object) => {
    if (object && typeof object.visible !== "undefined") {
        const scene = servObj.scene;
        setVis(object, false);
        if (object.parent) {
            object.parent.remove(object);
        } else {
            scene.remove(object);
        }
    }
};
